export const initialBuildState = {
    authentication: {
        forceNewPassword: false,
        forceRecoveryMechanism: false,
        forgottenPasswordType: "",
        loginType: "",
        passwordRecoveryMechanism: "",
        registrationType: "",
        supportEmailAddress: "",
      },
      loginInfo: {
        htmlContent: "",
        label: "",
      },
      organizationShortName: "",
      organizationType: "",
      tAndCs: {
        clientAgreeLinkText: "",
        htmlTermsConditionsContent: "",
      },
}